export default __webpack_public_path__ + "static/media/5.a6ff23b9.png";